exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-pin-toggle-container {\n  display: none;\n  position: relative;\n  width: 30px;\n  align-items: center;\n  justify-content: center;\n}\n.project-pin-toggle-container .anticon {\n  color: #9ba0aa !important;\n}\n.project-pin-toggle-container .unpin-diagonal-line {\n  position: absolute;\n  top: 65%;\n  left: 45%;\n  width: 18px;\n  height: 1px;\n  background: #9ba0aa;\n  transform: rotate(45deg) translate(-50%, -50%);\n  pointer-events: none;\n}\n.project-pin-toggle-container.pinned {\n  display: flex;\n}\n.ant-menu-submenu-active .project-pin-toggle-container:not(.pinned) {\n  display: flex;\n}\n", ""]);

// exports
